import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("sr_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// If the user was deleted by admin, auto-logout on 401 (protected endpoints)
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const url = err.config?.url || "";
    if (
      err.response?.status === 401 &&
      !url.includes("/auth/login") &&
      localStorage.getItem("sr_token")
    ) {
      localStorage.removeItem("sr_token");
      if (typeof window !== "undefined" && !window.location.pathname.startsWith("/logowanie")) {
        window.location.href = "/logowanie?expired=1";
      }
    }
    return Promise.reject(err);
  }
);

export default api;

export function formatErr(detail) {
  if (detail == null) return "Coś poszło nie tak. Spróbuj ponownie.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function resolveAssetUrl(url) {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  return `${BACKEND_URL}${url}`;
}
